import React from "react";
import { Modal } from "react-bootstrap";

const InfluencerConfirm = ({ show, handleClose, description }) => {
  return (
    <Modal
      backdrop="static"
      keyboard={false}
      show={show}
      centered
      className="request_modal"
      onHide={handleClose}
    >
      <Modal.Body>
        <div className="desc_box">
          <label htmlFor="desc">Notification </label>
          <div>{description}</div>
          <button type="submit" className="submit_btn" onClick={handleClose}>
            Go To Profile
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default InfluencerConfirm;
